// utils/tracking.js
// Note: GA4 and Facebook Pixel are now initialized in index.html
// This file handles React-specific tracking events using the global gtag and fbq functions

export const initTracking = () => {
  // Tracking is already initialized in index.html
  // Just send initial page view
  trackPageView(window.location.pathname + window.location.search);
};

export const trackGAEvent = (eventName, eventParams = {}) => {
  try {
    // Use gtag directly since it's already loaded
    if (window.gtag) {
      window.gtag('event', eventName, eventParams);
      console.log(`GA Event sent: ${eventName}`, eventParams);
    }
    trackFBEvent(eventName, eventParams);
    console.log(`FB Event sent: ${eventName}`, eventParams);

    // Add Pinterest tracking only for generate_look events
    trackPinEvent(eventName, eventParams);

  } catch (error) {
    console.error('Error sending GA event:', error);
  }
};


export const trackPageView = (url, skipCAPI = false) => {
  // Use gtag directly for GA4
  if (window.gtag) {
    window.gtag('config', 'G-XCXTCZFTN9', {
      page_path: url
    });
    console.log(`GA PageView sent: ${url}`);
  }
  
  // Use fbq directly for Facebook Pixel
  if (window.fbq) {
    window.fbq('track', 'PageView');
    console.log(`FB PageView sent: ${url}`);
  }

  // Use pintrk directly for Pinterest
  if (window.pintrk) {
    window.pintrk('track', 'pagevisit', {
      event_id: `pageview_${Date.now()}`,
      lead_type: url
    });
    console.log(`Pinterest PageVisit sent: ${url}`);
  }

  // Only send CAPI event if not skipped (to avoid duplicates)
  if (!skipCAPI) {
    try{
      // ✅ Meta Conversions API (Server)
      const eventId = generateUUID(); // same event ID for deduplication
      sendCAPIEvent('PageView', { page: url }, eventId);
    } catch {
      console.log("Error tracking CAPI event");
    }
  }
};


// 🔥 New helper function: track a custom event
export const trackFBEvent = (eventName, eventData = {}) => {
  const eventId = generateUUID(); // same event ID for deduplication

  // Track on browser pixel (non-blocking)
  if (window.fbq) {
    window.fbq('track', eventName, eventData, { eventID: eventId });
  }

  // Track on server via CAPI (non-blocking)
  sendCAPIEvent(eventName, eventData, eventId);
};

// Pinterest tracking function - only tracks generate_look events for ads
export const trackPinEvent = (eventName, eventData = {}) => {
  try {
    if (window.pintrk && eventName === 'generate_look') {
      // Map generate_look to Pinterest's 'lead' event for ads
      window.pintrk('track', 'lead', {
        lead_type: 'generate_look',
        ...eventData
      });
      console.log('✅ Pinterest Lead event sent for generate_look');
    }
    // Ignore all other events for Pinterest
  } catch (error) {
    console.error('❌ Error sending Pinterest event:', error);
  }
};

/*
const sendCAPIEvent_v0 = async (eventName, eventData, eventId) => {
  try {
    await axios.post(`/api/track-capi-event`, {
      eventName,
      eventData,
      eventId,
      pageUrl: window.location.href,
      userAgent: navigator.userAgent,
    });
  } catch (error) {
    console.error('Error sending event to backend CAPI API:', error);
  }
};
*/


const sendCAPIEvent = (eventName, eventData, eventId) => {
  // Fire and forget - don't await the response
  fetch("/api/track-capi-event", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      eventName,
      eventData,
      eventId,
      pageUrl: window.location.href,
      userAgent: navigator.userAgent,
    }),
  })
  .then(response => {
    if (!response.ok) {
      throw new Error("❌ Failed to send CAPI event");
    }
    return response.json();
  })
  .then(data => {
    console.log("✅ CAPI event sent successfully:", data);
  })
  .catch(error => {
    console.error("❌ Error sending CAPI event:", error);
  });
};



// 🔥 Utility to generate a random event ID
const generateUUID = () => {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    const r = (Math.random() * 16) | 0,
      v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
};
